

import { Check, Mail, TriangleAlert } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@sunfish/ui";

type MessageType = "success" | "error" | "email";

interface AuthMessageCardProps {
  type: MessageType;
  title: string;
  message: string;
  linkText?: string;
  linkHref?: string;
  buttonText?: string;
  buttonHref?: string;
}

const iconMap = {
  success: Check,
  error: TriangleAlert,
  email: Mail,
};

const iconColorMap = {
  success: "text-positive",
  error: "text-destructive",
  email: "text-brand",
};

export function AuthMessageCard({
  type,
  title,
  message,
  linkText,
  linkHref,
  buttonText,
  buttonHref,
}: AuthMessageCardProps) {
  const Icon = iconMap[type];

  return (
    <div>
      <Icon className={`h-7 w-7 ${iconColorMap[type]}`} strokeWidth={1.75} />
      <h1 className="mt-6 font-display text-headline text-foreground">{title}</h1>
      <p className="mt-2 text-body text-muted-foreground">{message}</p>
      {buttonText && buttonHref && (
        <Button variant="brand" size="lg" className="mt-8 w-full" asChild>
          <Link className={"w-full text-center"} to={buttonHref}>
            {buttonText}
          </Link>
        </Button>
      )}
      {linkText && linkHref && (
        <div className="mt-6">
          <Link
            to={linkHref}
            className="text-label font-medium text-muted-foreground hover:underline"
          >
            {linkText}
          </Link>
        </div>
      )}
    </div>
  );
}
